let currency;
theme.site == 'eu' ? currency = '€' : currency = '$';

export const money = (value) => {
  var str = String(parseFloat(value) / 100);
  str += (str.indexOf('.') < 0) ? '.00' : '00';
  return `${currency}${str.substring(0, str.indexOf('.') + 3)}`;
}

export const moneyWithoutDecimals = value => {
  const dollars = parseFloat(value) / 100;
  const str = String(dollars);
  if (value % 100 === 0) {
    return `${currency}` + str;
  }
  if (dollars < 1) {
    return `${currency}` + dollars.toFixed(2);
  }
  if (str.includes('.')) {
    return `${currency}` + str.substring(0, str.indexOf('.') + 3);
  }
  return `${currency}` + str.substring(0, str.length - 2);
}

export const moneyWithoutTrailingZeros = value => {
  const dollars = (value / 100);
  const str = String(dollars);
  if (value % 100 === 0) {
    return `${currency}` + str;
  }
  if (dollars < 1) {
    return `${currency}` + dollars.toFixed(2);
  }
  if (str.includes('.')) {
    return `${currency}` + dollars.toFixed(2);
  }
  return `${currency}` + str.substring(0, str.length - 2);
}